{
  "familyId": "REK-CONTEXT-PLUS-MIN",
  "questions": [
    {
      "id": "REK-CONTEXT-PLUS-MIN-001",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Je spaart voor een skateboard van €89. Je hebt al €47 gespaard. Je oma geeft je €25 voor je verjaardag. Hoeveel moet je nog sparen?",
      "options": ["€17", "€8", "€42", "€64"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_sparen_skateboard",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.78,
      "context": "Sparen voor skateboard",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst optellen, dan aftrekken",
            "content": "Stap 1: Hoeveel heb je nu? €47 + €25 = €72. Stap 2: Hoeveel moet je nog? €89 − €72 = €17. Tip: lees goed wat de vraag is — 'hoeveel moet je NOG sparen'.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-direction-wrong", "label": "Trekt cadeau af in plaats van op te tellen", "optionIndex": 1 },
          { "id": "rek.context-step-forgotten", "label": "Vergeet oma's cadeau op te tellen", "optionIndex": 2 },
          { "id": "rek.context-direction-wrong", "label": "Trekt verkeerd bedrag af", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Stap 1: Je hebt nu €47 + €25 (van oma) = €72. Stap 2: Het skateboard kost €89. Je moet nog €89 − €72 = €17 sparen. Lees goed: de vraag is hoeveel je NOG moet sparen.",
        "solutionSteps": [
          "Stap 1: Totaal gespaard — €47 + €25 = €72",
          "Stap 2: Nog nodig — €89 − €72 = €17",
          "Check: €72 + €17 = €89 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €47 + €25 = €72 gespaard. €89 − €72 = €17 nog nodig.",
          "1": "Je dacht waarschijnlijk €89 − €47 − €25 − €17 = €0, of je trok het cadeau er juist af i.p.v. erbij op te tellen. Oma's €25 maakt het tekort kleiner, niet groter. Het juiste antwoord is €17.",
          "2": "Je berekende hoeveel je hebt (€47 + €25 = €72), maar de vraag is hoeveel je NOG moet sparen. €89 − €72 = €17.",
          "3": "Je dacht waarschijnlijk €89 − €25 = €64. Maar je moet eerst je spaargeld en het cadeau optellen: €47 + €25 = €72. Dan: €89 − €72 = €17."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-002",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Bij sportvereniging De Toekomst liggen 's ochtends 1.250 ballen in het magazijn. Er worden 387 ballen meegenomen voor wedstrijden en 's middags komen er 145 nieuwe ballen geleverd. Hoeveel ballen liggen er aan het eind van de dag?",
      "options": ["1.008 ballen", "1.782 ballen", "863 ballen", "1.108 ballen"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_voorraad",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.80,
      "context": "Sportclub-magazijn",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lees de richting: erbij of eraf?",
            "content": "Meegenomen = eraf (−). Geleverd = erbij (+). Reken: 1.250 − 387 = 863, dan 863 + 145 = 1.008.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-direction-wrong", "label": "Telt alles op i.p.v. meegenomen af te trekken", "optionIndex": 1 },
          { "id": "rek.context-step-forgotten", "label": "Vergeet de geleverde ballen op te tellen", "optionIndex": 2 },
          { "id": "rek.carry-forgotten", "label": "Rekenfout bij aftrekken of optellen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Meegenomen = eraf: 1.250 − 387 = 863. Geleverd = erbij: 863 + 145 = 1.008 ballen. Markeer in de tekst wat erbij komt (+) en wat eraf gaat (−).",
        "solutionSteps": [
          "Stap 1: Begin — 1.250 ballen",
          "Stap 2: Meegenomen (−) — 1.250 − 387 = 863",
          "Stap 3: Geleverd (+) — 863 + 145 = 1.008",
          "Check: 1.008 ballen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.250 − 387 + 145 = 1.008 ballen.",
          "1": "Je telde alles op: 1.250 + 387 + 145 = 1.782. Maar 387 ballen werden MEEGENOMEN — dat is aftrekken.",
          "2": "Je berekende 1.250 − 387 = 863, maar vergat de 145 ballen die geleverd werden. 863 + 145 = 1.008.",
          "3": "Controleer je berekening: 1.250 − 387 = 863, dan 863 + 145 = 1.008 (niet 1.108)."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-003",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "step_solver",
      "question": "Je hebt 500 V-Bucks in Fortnite. Je koopt een skin voor 200 V-Bucks en een emote voor 150 V-Bucks. Daarna win je een wedstrijd en krijgt 75 V-Bucks. Hoeveel V-Bucks heb je nu?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Hoeveel V-Bucks heb je na de skin? (500 − 200)", "correctAnswer": "300", "hint": "Kopen betekent dat het eraf gaat. Trek 200 af van je startbedrag (500).", "explanation": "500 − 200 = 300 V-Bucks" },
          { "prompt": "Hoeveel na de emote? (300 − 150)", "correctAnswer": "150", "hint": "Weer iets gekocht! Trek 150 af van het bedrag dat je na de skin over had.", "explanation": "300 − 150 = 150 V-Bucks" },
          { "prompt": "Hoeveel na de wedstrijd? (150 + 75)", "correctAnswer": "225", "hint": "Winnen betekent dat je er V-Bucks bij krijgt. Tel 75 op bij wat je nog had.", "explanation": "150 + 75 = 225 V-Bucks" }
        ],
        "finalAnswer": "225"
      },
      "conceptId": "context_plus_min_gaming_vbucks",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.76,
      "context": "Fortnite V-Bucks",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap: kopen = eraf, winnen = erbij",
            "content": "Begin: 500. Skin kopen (−200): 300. Emote kopen (−150): 150. Wedstrijd winnen (+75): 225 V-Bucks.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Werk stap voor stap: 500 − 200 = 300 (skin). 300 − 150 = 150 (emote). 150 + 75 = 225 (wedstrijd gewonnen). Je hebt nu 225 V-Bucks.",
        "solutionSteps": [
          "Stap 1: 500 − 200 = 300 (skin gekocht)",
          "Stap 2: 300 − 150 = 150 (emote gekocht)",
          "Stap 3: 150 + 75 = 225 (wedstrijd gewonnen)",
          "Check: 225 V-Bucks ✓"
        ]
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-004",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "De schoolfeestcommissie maakt aan het einde van de avond de kassa op. Vooraf zat er €487,50 in. Tijdens het feest is er €1.235,75 binnengekomen aan ticketverkoop, en is er €362,80 wisselgeld teruggegeven. Hoeveel zit er nu in de kassa?",
      "options": ["€1.360,45", "€1.723,25", "€2.086,05", "€1.598,25"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_geld_kassa",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.82,
      "context": "Schoolfeest-kassa",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ontvangen = erbij, teruggegeven = eraf",
            "content": "Begin: €487,50. Ontvangen (+): €487,50 + €1.235,75 = €1.723,25. Wisselgeld (−): €1.723,25 − €362,80 = €1.360,45.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet wisselgeld af te trekken", "optionIndex": 1 },
          { "id": "rek.context-direction-wrong", "label": "Telt alle bedragen op", "optionIndex": 2 },
          { "id": "rek.partial-calculation", "label": "Begint niet bij het startbedrag", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin: €487,50. Ontvangen (+): 487,50 + 1.235,75 = 1.723,25. Wisselgeld terug (−): 1.723,25 − 362,80 = 1.360,45. Er zit nu €1.360,45 in de kassa.",
        "solutionSteps": [
          "Stap 1: Begin — €487,50",
          "Stap 2: Ontvangen (+) — 487,50 + 1.235,75 = 1.723,25",
          "Stap 3: Wisselgeld (−) — 1.723,25 − 362,80 = 1.360,45",
          "Check: €1.360,45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €487,50 + €1.235,75 − €362,80 = €1.360,45.",
          "1": "Je vergat het wisselgeld af te trekken. Er is €362,80 teruggegeven: 1.723,25 − 362,80 = 1.360,45.",
          "2": "Je telde alles op. Maar wisselgeld wordt TERUGGEGEVEN — dat is aftrekken.",
          "3": "Je vergat het startbedrag (€487,50). Begin altijd bij wat er al in de kassa zit."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-005",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "true_false_series",
      "question": "Hoort de berekening bij het verhaaltje? Beoordeel per stelling of de berekening klopt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Je hebt 350 volgers op TikTok. Er komen 128 bij en 45 stoppen. Berekening: 350 + 128 − 45 = 433",
            "isTrue": true
          },
          {
            "text": "Een winkel heeft 820 artikelen. Er worden 265 verkocht en 180 nieuwe geleverd. Berekening: 820 − 265 − 180 = 375",
            "isTrue": false
          },
          {
            "text": "Je hebt €150. Je koopt schoenen van €65 en een shirt van €28. Berekening: 150 − 65 − 28 = 57",
            "isTrue": true
          }
        ]
      },
      "conceptId": "context_plus_min_judge_richting",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.78,
      "context": "Berekening bij verhaaltje",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Erbij = optellen, eraf = aftrekken",
            "content": "Lees het verhaaltje goed. Woorden als 'bijkomen', 'erbij', 'geleverd' = optellen (+). Woorden als 'verkocht', 'kopen', 'stoppen' = aftrekken (−).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Let op signaalwoorden: 'bijkomen/geleverd' = optellen, 'verkocht/kopen/stoppen' = aftrekken. De tweede berekening klopt niet: 'nieuwe geleverd' is optellen, niet aftrekken.",
        "solutionSteps": [
          "Paar 1: bijkomen (+128), stoppen (−45) → 350 + 128 − 45 = 433 ✓",
          "Paar 2: verkocht (−265), geleverd (+180) → moet zijn 820 − 265 + 180 = 735 ✗",
          "Paar 3: kopen (−65), kopen (−28) → 150 − 65 − 28 = 57 ✓"
        ]
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-006",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar heeft 3 kasten met boeken. In de eerste kast staan 248 boeken, in de tweede 175 en in de derde 312. Ze verkoopt er 89. Hoeveel boeken heeft ze nog?",
      "options": ["646", "735", "624", "736"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_meerdere_optellen",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "context": "Boekwinkel",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst optellen, dan aftrekken",
            "content": "Totaal: 248 + 175 + 312 = 735. Verkocht: 735 − 89 = 646.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet verkochte af te trekken", "optionIndex": 1 },
          { "id": "rek.carry-forgotten", "label": "Rekenfout bij aftrekken", "optionIndex": 2 },
          { "id": "rek.carry-forgotten", "label": "Optelfout bij totaal", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Totaal: 248 + 175 + 312 = 735 boeken. Verkocht: 735 − 89 = 646 boeken over.",
        "solutionSteps": [
          "Stap 1: 248 + 175 = 423",
          "Stap 2: 423 + 312 = 735 totaal",
          "Stap 3: 735 − 89 = 646 boeken over",
          "Check: 646 + 89 = 735 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 248 + 175 + 312 = 735, dan 735 − 89 = 646.",
          "1": "Je berekende het totaal (735) maar vergat de 89 verkochte boeken af te trekken.",
          "2": "Controleer: 735 − 89 = 646, niet 624. Misschien een leenfout bij het aftrekken.",
          "3": "Controleer: 248 + 175 = 423, dan 423 + 312 = 735, niet 736."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-007",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "De schoolbibliotheek heeft 1.500 boeken. Op maandag worden er 345 boeken uitgeleend. Op dinsdag brengen leerlingen 120 boeken terug. Hoeveel boeken staan er nu in de bibliotheek?",
      "options": ["1.275", "1.035", "1.725", "1.155"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_bibliotheek",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.78,
      "context": "Schoolbibliotheek",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitlenen = eraf, terugbrengen = erbij",
            "content": "Begin: 1.500. Uitgeleend (−): 1.500 − 345 = 1.155. Teruggebracht (+): 1.155 + 120 = 1.275.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-direction-wrong", "label": "Trekt teruggebrachte boeken ook af", "optionIndex": 1 },
          { "id": "rek.context-direction-wrong", "label": "Telt uitgeleende boeken op", "optionIndex": 2 },
          { "id": "rek.context-step-forgotten", "label": "Vergeet teruggebrachte boeken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Uitlenen betekent dat de boeken weggaan (−). Terugbrengen betekent dat ze weer in de kast komen (+). Dus: 1.500 − 345 = 1.155. Dan 1.155 + 120 = 1.275 boeken.",
        "solutionSteps": [
          "Begin: 1.500 boeken",
          "Uitgeleend (−): 1.500 − 345 = 1.155",
          "Teruggebracht (+): 1.155 + 120 = 1.275",
          "Antwoord: 1.275 boeken"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.500 − 345 + 120 = 1.275 boeken.",
          "1": "Je hebt de teruggebrachte boeken ook afgetrokken: 1.155 − 120 = 1.035. Maar teruggebrachte boeken komen ERBIJ in de bibliotheek (+).",
          "2": "Je hebt de uitgeleende boeken opgeteld: 1.500 + 345 = 1.845. Maar uitgeleend betekent dat ze WEGGAAN (−).",
          "3": "Je berekende 1.500 − 345 = 1.155, maar vergat de 120 teruggebrachte boeken erbij op te tellen."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-008",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "In een dierentuin zijn 's ochtends 450 bezoekers binnengekomen. 's Middags komen er nog 680 bezoekers bij. Aan het eind van de middag gaan er 210 bezoekers naar huis. Hoeveel bezoekers zijn er dan nog in de dierentuin?",
      "options": ["920", "1.340", "1.130", "820"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_dierentuin",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "context": "Dierentuin bezoekers",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Binnenkomen = erbij, naar huis = eraf",
            "content": "Ochtend: 450. Middag erbij (+): 450 + 680 = 1.130. Naar huis (−): 1.130 − 210 = 920.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-direction-wrong", "label": "Telt alle bezoekers op", "optionIndex": 1 },
          { "id": "rek.context-step-forgotten", "label": "Vergeet de vertrekkende bezoekers af te trekken", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Rekenfout bij optellen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Binnenkomen is optellen (+), naar huis gaan is aftrekken (−). Dus: 450 + 680 = 1.130 bezoekers. Dan gaan er 210 naar huis: 1.130 − 210 = 920 bezoekers over.",
        "solutionSteps": [
          "Ochtend: 450",
          "Middag erbij (+): 450 + 680 = 1.130",
          "Naar huis (−): 1.130 − 210 = 920",
          "Antwoord: 920 bezoekers"
        ],
        "distractorExplanations": {
          "0": "Goed! 450 + 680 − 210 = 920.",
          "1": "Je telde alles op: 450 + 680 + 210 = 1.340. Maar de 210 bezoekers gingen NAAR HUIS, dus die moet je aftrekken.",
          "2": "Je berekende 450 + 680 = 1.130, maar vergat de 210 vertrekkende bezoekers af te trekken.",
          "3": "Je maakte waarschijnlijk een rekenfout bij het optellen: 450 + 680 = 1.130 (niet 1.030). Dan 1.130 − 210 = 920."
        }
      }
    }
  ]
}